import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HeroSection from "@/components/sections/HeroSection";
import ProblemSection from "@/components/sections/ProblemSection";
import SolutionSection from "@/components/sections/SolutionSection";
import HowItWorksSection from "@/components/sections/HowItWorksSection";
import ProductPreviewSection from "@/components/sections/ProductPreviewSection";
import FeaturesSection from "@/components/sections/FeaturesSection";
import UseCasesSection from "@/components/sections/UseCasesSection";
import BenefitsSection from "@/components/sections/BenefitsSection";
import ApplicationFormSection from "@/components/sections/ApplicationFormSection";
import FinalCTASection from "@/components/sections/FinalCTASection";

export default function LandingPage() {
  return (
    <div className="min-h-screen" data-testid="landing-page">
      <Navbar />
      <HeroSection />
      <ProblemSection />
      <SolutionSection />
      <HowItWorksSection />
      <ProductPreviewSection />
      <FeaturesSection />
      <UseCasesSection />
      <BenefitsSection />
      <ApplicationFormSection />
      <FinalCTASection />
      <Footer />
    </div>
  );
}
